import { TOKEN_REFRESH } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface RefreshState extends BaseAsyncReducerState {
    token: string;
    refresh: string;
    exp: number
}

// Define an initial state value for the app
const initialState: RefreshState = {
    loading: false,
    error: false,
    token: "",
    refresh: "",
    exp: 0
}
  
function refreshReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case TOKEN_REFRESH.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }

        case TOKEN_REFRESH.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,
            }

        case TOKEN_REFRESH.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }

        case TOKEN_REFRESH.RESET:
            return {
                ...state,
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default refreshReducer;